import { DOCUMENTS_API } from '@Constants/backendConstants';
import {
    EnumOperation,
    ListRequest,
    FilterCondition,
    EnumFilterExpressionOperation,
} from '@synqo/frontend-component-library';

import { useCallback } from 'react';
import { useListApi } from '@Hooks/useListApi';
import { DynamicExportRunRepository } from '@Repositories/Documents';

export function useLoadExportRuns(category: string, key: string) {
    const listApi = useListApi(DynamicExportRunRepository, DOCUMENTS_API);

    const loadPage = useCallback(
        (listRequest: ListRequest) => {
            const filters: FilterCondition[] = [
                {
                    field: 'category',
                    value: category,
                    operator: EnumOperation.Equal,
                },
                {
                    field: 'key',
                    value: key,
                    operator: EnumOperation.Equal,
                },
            ];

            if (listRequest.filter_columns === undefined) {
                listRequest.filter_columns = { operation: EnumFilterExpressionOperation.And, filters: [] };
            }

            listRequest.filter_columns.filters.push(...filters);

            return listApi.loadPage(listRequest);
        },
        [category, key, listApi],
    );

    return {
        loadPage,
    };
}
